import React, { Fragment } from 'react'
import LandingNews from '../../news/landing'
import ExploreTitle from './explore-title'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import OrganiserButton from './organiser-button'
import { i18n } from '../../../validator'
import SwiperConfigurator from '../../../front/components/signpost/swiper-config'
import { NavLink } from '../../../front/components/shared/sn-link'

@i18n()
class Header extends SwiperConfigurator {
    state = {
        showArrow: false,
    }

    componentDidMount = () => {
        setTimeout(() => this.showArrow(), 5000)
    }

    showArrow = () => {
        this.setState({ showArrow: true })
    }

    render() {
        const { showArrow } = this.state
        const { t } = this.props
        const {
            REACT_APP_IMAGES_FOLDER,
            REACT_APP_LANDING_SITE_NAME,
        } = this.config

        return (
            <Fragment>
                <div className="Header">
                    <header className="Header-container">
                        <div className="Header-main">
                            <div className="Header-left">
                                <div className="Header-left--main">
                                    <div className="Header-left--logo">
                                        <span dangerouslySetInnerHTML={{ __html: REACT_APP_LANDING_SITE_NAME }} />
                                    </div>
                                    <div className="Header-left--text">
                                        {t('headerTitle')}
                                    </div>
                                </div>
                            </div>
                            <div className="Header-right">
                                <div className="Header-right--phone">
                                    <img src={`${REACT_APP_IMAGES_FOLDER}galaxy-splash.png`} alt="" />
                                </div>
                                <div className="Header-right--phone">
                                    <img src={`${REACT_APP_IMAGES_FOLDER}ios-splash.png`} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="Header-buttons">
                            <NavLink to="/top-udalosti" className="Header-buttons--element">
                                <img src={`${REACT_APP_IMAGES_FOLDER}icons/top-events.svg`} alt="" />
                                <div className="landing">
                                    {t('headerButtonsTopEvents')}
                                </div>
                            </NavLink>
                            <NavLink to="/pro-deti" className="Header-buttons--element">
                                <img src={`${REACT_APP_IMAGES_FOLDER}icons/kids.svg`} alt="" />
                                <div className="landing">
                                    {t('headerButtonsSportForChildren')}
                                </div>
                            </NavLink>
                            <NavLink to="pro-sportujici" className="Header-buttons--element">
                                <img src={`${REACT_APP_IMAGES_FOLDER}icons/sports.svg`} alt="" />
                                <div className="landing">
                                    {t('headerButtonsSportForAthletes')}
                                </div>
                            </NavLink>
                            <NavLink to="/pro-divaky" className="Header-buttons--element">
                                <img src={`${REACT_APP_IMAGES_FOLDER}icons/cheer-big.svg`} alt="" />
                                <div className="landing">
                                    {t('headerButtonsForCheer')}
                                </div>
                            </NavLink>
                            <NavLink to="/chci-byt-informovan" className="Header-buttons--element">
                                <img src={`${REACT_APP_IMAGES_FOLDER}icons/information-whistle.svg`} alt="" />
                                <div className="landing">
                                    {t('headerButtonsMoreInfo')}
                                </div>
                            </NavLink>
                            <OrganiserButton />
                        </div>
                        <ExploreTitle />
                    </header>

                    <LandingNews />
                </div>
                {showArrow && !this.isChebSystem() &&
                    <AnchorLink href="#akce" className="Header-nav">
                        <div className="Header-arrow">
                            <div className="Header-arrow--in">
                                <span className="Header-circle text-center">
                                    <span className="Header-text text-uppercase text-muted">{t('down')}</span>
                                    <i className="Header-fa fas fa-angle-down text-muted" />
                                </span>
                                <span className="Header-pulse" />
                            </div>
                        </div>
                    </AnchorLink>
                }
            </Fragment>

        )
    }
}

export default Header
